import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { KreuzfahrtFilters } from '@app/models/filtermodels/KreuzfahrtFilters';
import { CruiseFiltersService } from '@app/services/cruis/cruisefilters.service';
import { Subject, takeUntil } from 'rxjs';
import { cruisesearchTypes, cruisegsPrice, cruisecabinCat, cruiselanguage, cruisemaxPass, cruisereiseDauer } from '../../tools/CruiseStatic';

interface Item {
    name: string;
    function: string;
    index?: number,
    field?: string;
}

@Component({
    selector: 'clever-cruiseselectedfilters',
    templateUrl: './cruiseselectedfilters.component.html',
    styleUrls: ['./cruiseselectedfilters.component.scss'],
    standalone: false
})
export class CruiseselectedfiltersComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() isDisabled: boolean = false;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    list: Item[] = [];
    filter: KreuzfahrtFilters;
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected cruiseFilterService: CruiseFiltersService,
        protected cdr: ChangeDetectorRef,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    initFilterSub(): void {
        this.cruiseFilterService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: KreuzfahrtFilters) => {
            if (filter) {
                this.checkFilters(filter);
            }
        });
    }

    checkFilters(filter): void {
        this.list = [];
        this.cdr.markForCheck();
        this.filter = JSON.parse(JSON.stringify(filter));
        this.checlpromo();
        this.checkSearchType('cruisesuchetype', cruisesearchTypes);
        this.checkSearchType('cruiseduration', cruisereiseDauer);
        this.checkSearchType('cruiseboardlanguage', cruiselanguage);
        this.checkSearchType('cruisemaxprice', cruisegsPrice);
        this.checkSearchType('cruisecabincat', cruisecabinCat);
        this.checkSearchType('cruisemaxanzpass', cruisemaxPass);
        this.cdr.markForCheck();
        this.cruiseFilterService.setExtraCount(this.list.length);
    }

    async resetAll() {
        this.cruiseFilterService.resetAllExtras();
    }

    checlpromo(): void {
        if (this.filter?.promo?.length > 0) {
            this.list.push({
                name: this.filter?.promo,
                function: 'removepromo',
            });
        }
    }

    async removepromo() {
        this.filter.promo = '';
        this.filter.pmc = '';
        this.cruiseFilterService.promo('');
        this.cruiseFilterService.pmc('');
        this.cruiseFilterService.changeUrl();
    }

    checkSearchType(type, array): void {
        if (this.filter?.[type]?.length > 0) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].id === this.filter[type]) {
                    this.list.push({
                        name: array[i].name,
                        function: 'remove' + type,
                    });
                }
            }
        }
    }

    async removecruisesuchetype() {
        this.filter.cruisesuchetype = '';
        this.cruiseFilterService.cruisesuchetype('', true);
    }

    async removecruiseduration() {
        this.filter.cruiseduration = '';
        this.cruiseFilterService.cruiseduration('', true);
    }

    async removecruisemaxprice() {
        this.filter.cruisemaxprice = '';
        this.cruiseFilterService.cruisemaxprice('', true);
    }

    async removecruisemaxanzpass() {
        this.filter.cruisemaxanzpass = '';
        this.cruiseFilterService.cruisemaxanzpass('', true);
    }

    async removecruisecabincat() {
        this.filter.cruisecabincat = '';
        this.cruiseFilterService.cruisecabincat('', true);
    }

    async removecruiseboardlanguage() {
        this.filter.cruiseboardlanguage = '';
        this.cruiseFilterService.cruiseboardlanguage('', true);
    }
}
